module.exports = __webpack_public_path__ + "img/coupon-gift-left-double.a5a3e8f.png";